import Vue from 'vue'
import AscDatePicker from '@/components/atoms/AscDatePicker'

export default Vue.extend({
  components: {
    AscDatePicker,
  },

  data: function () {
    return {
      currentValue: {
        dates: {
          value: '0',
          startDate: null,
          endDate: null,
        },
      },
      disabled: true,
    }
  },

  computed: {
    getCustomAttrs() {
      return this.params && this.params.dateFloatFilterConfig
        ? this.params.dateFloatFilterConfig
        : {}
    },
  },

  beforeMount() {
    this.disabled = !!(this.params.items && this.params.items.length === 0)

    // Persistent filter
    let dateSelections = []
    if (Object.prototype.hasOwnProperty.call(this.params, 'persistentGridId')) {
      const persistentGridId = this.params.persistentGridId
      const filterModel = sessionStorage.getItem(`${persistentGridId}_filter`)
      if (filterModel) {
        const parsedFilterModel = JSON.parse(filterModel)
        if (
          Object.prototype.hasOwnProperty.call(
            parsedFilterModel,
            this.params.column.colId,
          )
        ) {
          const value =
            parsedFilterModel[this.params.column.colId].filter.split(',')

          if (value.length === 3) {
            dateSelections = {
              dates: {
                value: value[0] || '0',
                startDate: value[1] || null,
                endDate: value[2] || null,
              },
            }
          }
        }
      }
    } else {
      console.warn('N/A persistentGridId')
    }

    if (Object.keys(dateSelections).length) {
      this.handleInput(dateSelections)
    }
  },

  methods: {
    handleInput(value) {
      if (Object.prototype.hasOwnProperty.call(value, 'dates')) {
        const dates = value.dates
        if (
          Object.prototype.hasOwnProperty.call(dates, 'value') &&
          Object.prototype.hasOwnProperty.call(dates, 'startDate') &&
          Object.prototype.hasOwnProperty.call(dates, 'endDate')
        ) {
          if (dates.value === '0') {
            this.params.parentFilterInstance(function (instance) {
              instance.onFloatingFilterChanged(null, null)
            })
          } else {
            // Incoming value has to have the same structure as currentValue when intialized
            this.currentValue = value
            const updatedValue = `${dates.value},${dates.startDate},${dates.endDate}`
            const valueToUse = dates.value === '0' ? null : updatedValue
            this.params.parentFilterInstance(function (instance) {
              instance.onFloatingFilterChanged('dates', valueToUse)
            })
          }
        }
      }
    },
    onParentModelChanged(parentModel) {
      // setFilterModel should trigger this and hence we can update the float filters based on the parentmodel data
      if (parentModel) {
        const value = parentModel.filter.split(',')
        this.currentValue = {
          dates: {
            value: value[0] || '0',
            startDate: value[1] && value[1] !== 'null' ? value[1] : null,
            endDate: value[2] && value[2] !== 'null' ? value[2] : null,
          },
        }
      }
    },
  },

  template: `<asc-date-picker
  v-model="currentValue"
  :hide-options-with-id="[6]"
  :show-fixed-options="true"
  :has-icon="true"
  :disabled="disabled"
  icon-position="right"
  icon="mdi-filter"
  v-bind="getCustomAttrs"
  :attach="false"
  @input="handleInput"
  float-filter></asc-date-picker>`,
})
